// extracted by mini-css-extract-plugin
export default {"form":"NovaVersao_form__-l4uT","areaBtn":"NovaVersao_areaBtn__3EKgz","btn":"NovaVersao_btn__LA2Ov","btn2":"NovaVersao_btn2__xJKbn"};